import type { OptionCard } from '../../../components/option-card-group/option-card-group';

export const ROLE_LABELS: Record<string, string> = {
  owner: 'Owner',
  admin: 'Admin',
  creator: 'Creator',
  guest: 'Guest',
};

export const getRoleLabel = (role?: string): string =>
  ROLE_LABELS[role?.toLowerCase() ?? ''] ?? role ?? '';

/**
 * Roles a member can be moved to from the space settings.
 *
 * `owner` and `guest` are absent on purpose: the API rejects both on
 * `PATCH /spaces/:spaceId/members/:memberId`. A guest is promoted through the
 * seat-checked `promote` endpoint instead.
 */
export const ASSIGNABLE_ROLE_OPTIONS: OptionCard[] = [
  {
    value: 'admin',
    title: 'Admin',
    description:
      'Administrator has full access, including managing users and deleting current administrators.',
  },
  {
    value: 'creator',
    title: 'Creator',
    description: 'Creators can create projects, edit everything, download and share files.',
  },
];
